<template>
  <div class="tab-line">
    <div class="tab-item"
    v-for="(item, index) in tabData"
      @click="handleSwitch(item)"
      :class="{ active: tabIndex == item.value}"
      :style="{ color: tabIndex == item.value ? '#FE4D45' : '','border-top': tabIndex == item.value ? '2px solid ' + '#FE4D45' : ''}"
    >
    {{ item.label }}
      <span></span>
    </div>
    <!-- <div
      class="tab_item"
      v-for="(item, index) in tabData"
      :key="index"
      @click="handleSwitch(item)"
      :class="{
        active: tabIndex == item.value,
        first: index == 0,
        last: index == tabInfo.length - 1,
      }"
    >
      {{ item.label }}
      <span></span>
    </div> -->
  </div>
</template>

<script>
export default {
  props: {
    tabInfo: {
      type: Array,
      default: () => [],
    },
    isReturnObj: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tabData: [],
      tabIndex: null,
    };
  },
  computed: {
    permissions() {
      return this.$store.getters.loginUserInfo.permissions;
    }
  },
  mounted() {
    // 根据权限过滤数据
    this.tabData = this.tabInfo.filter(
      (tab) => !tab.permissions || this.permissions.includes(tab.permissions)
    );
    // 默认选中第一项
    if (this.tabData.length) {
      this.tabIndex = this.tabData[0].value;
    }
    this.$emit("tabIndex", this.tabIndex);
  },
  methods: {
    handleSwitch(val) {
      if (this.isReturnObj) {
        this.tabIndex = val.value;
        this.$emit("switch", val);
      } else {
        this.tabIndex = val.value;
        this.$emit("switch", val.value);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-line {
  font-size: 14px;
  color: #666666;
  border-bottom: 1px solid #dddddd;
  margin: 20px 28px 0 28px;
  .tab-item {
    text-align: center;
    width: 120px;
    height: 36px;
    line-height: 36px;
    display: inline-block;
    position: relative;
    cursor: pointer;
    margin-right: 2px;
    border: 1px solid #dddddd;
    border-bottom: none;
    span {
      position: absolute;
      width: 100%;
      left: 50%;
      height: 2px;
      transform: translateX(-50%);
      bottom: -2px;
      display: none;
    }
    &.active {
      border-top: 2px;
      span {
        display: block;
        background: #fff;
      }
    }
  }
}
</style>
